import React from "react";
import { useTheme, Caption } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
export const ErrorMessage = ({ errors, formName, style }: any) => {
  const theme = useTheme() as ThemeType;
  return errors?.[formName]?.message ? (
    <Caption style={{ color: theme.colors.error, marginLeft: theme.spacing.smaller, ...style }}>
      {errors?.[formName]?.message}
    </Caption>
  ) : null;
};
